import { Layout, theme } from 'antd';
import Footers from '../../components/Footer';
import Headers from '../../components/Header';
import Siders from '../../components/Sider';
import Fakturas from '../../components/Guideaz/PDFS';

const { Content } = Layout;

const Order = () => {
    const { token: { colorBgContainer } } = theme.useToken();

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Siders />
            <Layout style={{ minHeight: '100vh' }}>
                <Headers />
                <div
                    className="pdf-scroll"
                    style={{
                        background: colorBgContainer,
                        padding: 4,
                        minHeight: 380,
                        overflowX: 'auto',
                        overflowY: 'auto',
                        WebkitOverflowScrolling: 'touch',
                    }}
                >
                    <div className="pdf-inner">
                        <Fakturas />
                    </div>
                </div>
                <Footers />
            </Layout>
        </Layout>
    );
};

export default Order;
